import { TEXT_AREA_VARIANTS } from './types';

export const VARIANT_TO_CLASS = {
  [TEXT_AREA_VARIANTS.DEFAULT]: {
    base: 'bg-sand-50 border-neutral-500 text-neutral-300 placeholder:text-neutral-100',
    focus: 'focus:border-primary-300 focus:shadow-focus',
    invalid: 'border-system-error-400 focus:border-system-error-400 focus:shadow-focus-error',
  },
  [TEXT_AREA_VARIANTS.INPUT_STYLE]: {
    base: 'bg-mercury-100 border-transparent text-neutral-800 placeholder:text-neutral-300 rounded-br',
    focus: 'focus:outline-none focus:border-neutral-50 hover:bg-mercury-200',
    invalid: 'border-system-error-400 focus:border-system-error-400 focus:shadow-focus-error',
  },
};
